import { Component, OnInit } from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {ConfService} from '../../conf.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';

interface Main {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ipconfig',
  templateUrl: './ipconfig.component.html',
  styleUrls: ['./ipconfig.component.scss']
})
export class IpconfigComponent implements OnInit {
  // type: string;
  items: any;
  type = 'data';
  attribute = 'configurations.ip_groups';
  addbuttontext = 'Add IP Group';
  schema: any;
  serviceOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
      'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
      'Access-Control-Allow-Origin': '*',
      'observe': 'response'
    })
  };
  constructor(public settingComp: SettingsComponent, private appComp: AppComponent, public confPost: ConfService, public _service: ConnecttocrudService) { }
  ngOnInit() {
    this.appComp.currentPageTitle = 'Manage IP Configuration';
    this.appComp.ribbon = 'IP Configuration';
    if (!this.settingComp.item) {
      this.settingComp.setcolumnvalues();
    }
    this.confPost.getSettingsCRUD(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
      this.items = {
        'sourcetype': this.type,
        'data': data[0]['configurations']['ip_groups'],
        'patchUrl': environment.apihost + '/v1/data/services/services/settings/' + data[0]['id'],
        'headers': this.serviceOptions
      };
    });
    this.confPost.getEntity('services', 'services', 'settings', 'v1').subscribe(data => {
     this.schema = data['attributes'][2]['subType'][0]['subType'];
    });
  }
  stringifyjson(val) {
    return JSON.stringify(val, null, 2).trim();
  }
}
